const ROUTE_PREFIX = '/indirect-tax';
const ENTITY_ID_REGEX = /\/indirect-tax\/(\d+)(?:\/|$|\?)/;
const SUB_PAGE_REGEX = /\/indirect-tax\/\d+\/(.+)$/;

export class IndirectTaxNavigationHelper {
  static get routePrefix(): string {
    return ROUTE_PREFIX;
  }

  static isOnIndirectTaxSurface(asPath: string): boolean {
    return asPath.startsWith(ROUTE_PREFIX);
  }

  static parseEntityIdFromUrl(asPath: string): number | null {
    const match = asPath.match(ENTITY_ID_REGEX);
    if (!match) return null;
    const parsed = parseInt(match[1], 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  static parseSubPage(asPath: string): string | null {
    const pathWithoutQuery = asPath.split('?')[0];
    const match = pathWithoutQuery.match(SUB_PAGE_REGEX);
    return match ? match[1] : null;
  }

  static buildEntityPath(entityId: number, subPage?: string | null): string {
    const basePath = `${ROUTE_PREFIX}/${entityId}`;
    return subPage ? `${basePath}/${subPage}` : basePath;
  }
}
